module.exports = __webpack_public_path__ + "static/media/Arrow_Left_Back_Dark.5d89f030.svg";